<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      router-link.btn.btn-primary(:to="{ name: 'atiGroupNew' }")
        i.fa.fa-plus
        span.ml5 New

    DataGrid(ref="grid" :fetch="fetchData" url-page-param="page")
      tr(slot="thead")
        th Name
        th Validation response
        th Default
        th
      tr(v-for="(i, index) in atis")
        td {{ i.name }}
        td {{ i.atis.ati | atiNamesFilter }}
        td {{ i.default }}
        td.actions
          router-link.btn-edit(title="Edit" :to="{ name: 'atiGroupEdit', params: { id: i.id } }")
          a.btn-trash(title="Delete" @click="remove(i.id)")

</template>
<script>
import miniToastr from 'mini-toastr'
import DataGrid from '@/components/ssp/DataGrid'
import Core from '@/service/apis/Core'
import { atiNamesFilter } from '@/filters/filters'

export default {
  data: () => ({
    atis: []
  }),
  methods: {
    fetchData(page) {
      return Core.listAtiGroups(page.maxOffsetRequest())
        .then((r) => {
          this.atis = r.data.atiGroup
          return r.data.totalRecords
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    remove(id) {
      this.$confirm({ text: 'Are you sure you want to delete this validation response group?' })
        .then((conf) => {
          if (conf) {
            Core.removeAtiGroup(id)
              .then(() => {
                miniToastr.success('Validation response group was deleted')
                this.$refs.grid.reload()
              })
              .catch((e) => {
                this.$emit('error', e)
              })
          }
        })
    },
  },
  components: {
    DataGrid
  },
  filters: {
    atiNamesFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/ati/AtiGroups.vue